/**
 * WekaTrust Logo Component
 * Uses the brand logo from public/wekatrust.png. Shows text fallback if image fails.
 */

import React, { useState } from 'react';

const SIZE_PX = {
  xs: 24,
  sm: 32,
  md: 40,
  lg: 48,
  xl: 56,
  '2xl': 64,
  header: 112,
  footer: 152,
};

// Vite: public assets are at root. BASE_URL is '/' unless deployed with base path.
const LOGO_SRC = typeof import.meta !== 'undefined' && import.meta.env?.BASE_URL
  ? `${import.meta.env.BASE_URL}wekatrust.png`
  : '/wekatrust.png';

/**
 * Logo component - displays WekaTrust brand logo with fallback
 */
const Logo = ({ size = 'md', className = '', alt = 'WekaTrust', ...props }) => {
  const [failed, setFailed] = useState(false);
  const px = SIZE_PX[size] ?? SIZE_PX.md;

  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        width: px,
        height: px,
        minWidth: px,
        minHeight: px,
        maxWidth: px,
        maxHeight: px,
        backgroundColor: failed ? '#0A66C2' : 'transparent',
        borderRadius: 6,
      }}
    >
      {failed ? (
        <span
          style={{
            fontSize: Math.round(px * 0.45),
            fontWeight: 700,
            color: '#fff',
            lineHeight: 1,
          }}
          aria-hidden
        >
          WT
        </span>
      ) : (
        <img
          src={LOGO_SRC}
          alt={alt}
          loading="eager"
          onError={() => setFailed(true)}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            objectPosition: 'center',
            display: 'block',
            verticalAlign: 'middle',
          }}
          {...props}
        />
      )}
    </span>
  );
};

export default Logo;
